import '@fontsource-variable/fira-code';
import '@fontsource-variable/inter';
import { useAppMode } from '@ui/hooks';
import { AppMode } from '@ui/constants';
import { App as AntdApp, ConfigProvider } from 'antd';
import { useEffect, useMemo } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { ToastContainer } from 'react-toastify';
import AuthWrapper from '../components/auth/AuthWrapper';
import './App.css';
import { preloadRoutes } from './preload';
import { createAppRouter } from './router';
import store from './store';
import { theme } from './theme';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';

function AppContent() {
    const mode: AppMode = useAppMode();
    const router = useMemo(() => createAppRouter(mode), [mode]);

    useEffect(() => {
        preloadRoutes(mode);
    }, [mode]);

    return <RouterProvider router={router} />;
}

export default function App() {
    return (
        <ConfigProvider theme={theme}>
            <AntdApp>
                <ReduxProvider store={store}>
                    <NuqsAdapter>
                        <AuthWrapper>
                            <AppContent />
                            <ToastContainer />
                        </AuthWrapper>
                    </NuqsAdapter>
                </ReduxProvider>
            </AntdApp>
        </ConfigProvider>
    );
}
